import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { all } from "redux-saga/effects";
import { createReduxHistoryContext } from "redux-first-history";
import { createBrowserHistory } from "history";
import thunk from "redux-thunk";

import reducers from "./reducers";
import sagas from "./sagas";

export const browserHistory = createBrowserHistory();

const {
  createReduxHistory,
  routerMiddleware,
  routerReducer,
} = createReduxHistoryContext({ history: browserHistory });

const sagaMiddleware = createSagaMiddleware();

// Custom middleware
const middleware = [sagaMiddleware, routerMiddleware, thunk];

export const storeNew = configureStore({
  reducer: {
    router: routerReducer,
    ...reducers,
    // ALL Reducers
    // units: unitsReducer,
    // unit: unitReducer,
    // configuration: configurationReducer,
  },
  middleware,
});

export const history = createReduxHistory(storeNew);

export default function* rootSaga() {
  const sagaArray = Object.values(sagas);
  if (sagaArray?.length > 0) {
    yield all(sagaArray.map(saga => saga()));
  }
}

sagaMiddleware.run(rootSaga);
